import styled from "@emotion/styled";
import { Grid } from "@mui/material";

export const StyledTwoColumnSection = styled(Grid)(() => ({
  paddingBlock: "0rem !important",
  margin: "0rem ",
  alignItems: "center",
  justifyContent: "center",
}));
